import React from "react";

const Spinner = () => {
  return (
    <div role="status">
      <div className=" inset-0 flex items-center justify-center bg-transparent bg-opacity-60 z-20">
        <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-primary"></div>
      </div>
    </div>
  );
};
export default Spinner;
